module.exports = __webpack_public_path__ + "static/carrot-836ade176319a446df5d1b9c7a8d9519.png";